import React from 'react';
import createSVG from './createSVG';

const DetailsIcon = ({style}) => (
  <path style={style} d="M9.213 17.525c4.536 0 8.213-3.7 8.213-8.262C17.426 4.7 13.75 1 9.213 1 4.678 1 1 4.7 1 9.263s3.678 8.262 8.213 8.262zm5.85-2.463l9.213 9.215M8.8 24.276h7.677m-7.678 0V10.31m0 0L16.476 1" stroke="#7D7D7D" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
);

export default createSVG(DetailsIcon);
